import type { SVGProps } from 'react';

const SvgVolumeOffLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M20 10L16 14M16 10L20 14L16 10Z' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M3 8.57143V15.4286H6L12 20V4L6 8.57143H3Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgVolumeOffLt;
